export { HeroNarrativeCarouselModule } from './Carousel';
export { HeroNarrativeCoverModule } from './Cover';
export { HeroNarrativeTextModule } from './Text';
export { HeroNarrativeQuoteModule } from './Quote';
